import type { AxiosRequestConfig } from 'axios';

import { network } from 'services/network';

/**
 * Fetches widget data using the endpoint provided by backend configuration.
 * Backend controls endpoints to support report restoration (e.g., summary feature).
 * * DO NOT modify endpoints manually - endpoint management is backend-controlled.
 */

export const getWidgetData = (params, endpoint, requestConfig?: AxiosRequestConfig) => {
    return network.post(endpoint, params, requestConfig).then((response) => {
        return response.data;
    });
};
